import { useEffect } from 'react';
import {
    ENABLE_Veneer_Shield_QUESTION,
    getEnableClearDesignQuestionList,
    getEnableEcodontWireSelect,
} from '../../../../pages/DiffRetainer/utils';
import useSetSelectDefaultValue from './useSetSelectDefaultValue';
/**
 * 为上下牙弓分开填写的保持器表单设置默认值，并清理 Veneer Shield 的隐藏选项残留。
 */
const useSetCombieFormDefaultValue = (formMethods, formValues) => {
    const upperIsVeneerShieldRetainer = ENABLE_Veneer_Shield_QUESTION.includes(formValues['UpperArchAndQuantity']);
    const lowerIsVeneerShieldRetainer = ENABLE_Veneer_Shield_QUESTION.includes(formValues['LowerArchAndQuantity']);

    useEffect(() => {
        if (
            upperIsVeneerShieldRetainer &&
            formValues['UpperFixedWire'] === 'true' &&
            formValues['UpperClearRetainerDesignUpperOption'] === 'NotCoverLingualOrPalatalWire'
        ) {
            formMethods.setValue('UpperClearRetainerDesignUpperOption', null);
        }

        if (
            lowerIsVeneerShieldRetainer &&
            formValues['LowerFixedWire'] === 'true' &&
            formValues['LowerClearRetainerDesignLowerOption'] === 'NotCoverLingualOrPalatalWire'
        ) {
            formMethods.setValue('LowerClearRetainerDesignLowerOption', null);
        }
    }, [formMethods, formValues, upperIsVeneerShieldRetainer, lowerIsVeneerShieldRetainer]);
    // for upper and lower retainer type
    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerLowTrimlineAreaSelect_1',
        defaultValue: '4-4',
        triggerValue: 'ecodontRetainerWithVeneerShield_1set',
        formMethods: formMethods,
        formValues: formValues,
    });
    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerLowTrimlineAreaSelect_3',
        defaultValue: '4-4',
        triggerValue: 'ecodontRetainerWithVeneerShield_3set',
        formMethods: formMethods,
        formValues: formValues,
    });
    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperLowTrimlineAreaSelect_1',
        defaultValue: '4-4',
        triggerValue: 'ecodontRetainerWithVeneerShield_1set',
        formMethods: formMethods,
        formValues: formValues,
    });
    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperLowTrimlineAreaSelect_3',
        defaultValue: '4-4',
        triggerValue: 'ecodontRetainerWithVeneerShield_3set',
        formMethods: formMethods,
        formValues: formValues,
    });
    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerBleachingRetainersSelect',
        defaultValue: '4-4',
        triggerValue: 'bleachingRetainers',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperPalatalWireSelect',
        defaultValue: 'Round Twist Wire',
        triggerValue: 'fixedPalatalWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperJigPlacementSelect',
        defaultValue: 'placement jig in middle of wire',
        triggerValue: 'fixedPalatalWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerPalatalWireSelect',
        defaultValue: 'Round Twist Wire',
        triggerValue: 'fixedPalatalWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerJigPlacementSelect',
        defaultValue: 'placement jig in middle of wire',
        triggerValue: 'fixedPalatalWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperSmartFitWireSelect',
        defaultValue: 'Round Twist Wire',
        triggerValue: 'MDLSmartFitRetainersWithWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerSmartFitWireSelect',
        defaultValue: 'Round Twist Wire',
        triggerValue: 'MDLSmartFitRetainersWithWire',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperEcodontWireSelect',
        // defaultValue : 'Round Twist Wire',
        defaultValue: 'Flat Twist Wire',
        triggerValue: getEnableEcodontWireSelect(),
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerEcodontWireSelect',
        // defaultValue : 'Round Twist Wire',
        defaultValue: 'Flat Twist Wire',
        triggerValue: getEnableEcodontWireSelect(),
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperEcodontRetainerWithWire_1setSelect',
        // defaultValue : 'Round Twist Wire',
        defaultValue: 'Flat Twist Wire',
        triggerValue: 'ecodontRetainerWithWire_1set',
        formMethods: formMethods,
        formValues: formValues,
    });

    useSetSelectDefaultValue({
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerEcodontRetainerWithWire_1setSelect',
        // defaultValue : 'Round Twist Wire',
        defaultValue: 'Flat Twist Wire',
        triggerValue: 'ecodontRetainerWithWire_1set',
        formMethods: formMethods,
        formValues: formValues,
    });

    // for upper clear retainer questions
    useSetSelectDefaultValue({
        // parentField:'UpperClearRetainerDesignUpper',
        parentField: 'UpperArchAndQuantity',
        childField: 'UpperClearRetainerDesignUpperOption',
        defaultValue: upperIsVeneerShieldRetainer ? undefined : 'NotCoverLingualOrPalatalWire',
        // triggerValue:true,
        // triggerValue: ENABLE_CLEAR_DESIGN_QUESTION,
        triggerValue: getEnableClearDesignQuestionList(formValues['UpperFixedWire'], false),
        formMethods: formMethods,
        formValues: formValues,
    });

    // useSetSelectDefaultValue({
    //   parentField:'UpperClearRetainerDesignLower',
    //   childField:'UpperClearRetainerDesignLowerOption',
    //   defaultValue:'NotCoverLingualOrPalatalWire',
    //   triggerValue:true,
    //   formMethods:formMethods,
    //   formValues:formValues
    // })

    // useSetSelectDefaultValue({
    //   parentField : 'UpperArchAndQuantity',
    //   childField:'UpperClearRetainerDesignUpperOptionForSecondSet',
    //   defaultValue: formValues['UpperArchAndQuantity'] === 'ecodontRetainers' && formValues['UpperFixedWire'] === 'true' ? 'NotCoverLingualOrPalatalWire' : undefined,
    //   // triggerValue: ENABLE_CLEAR_DESIGN_QUESTION_FOR_SECOND_SET,
    //   triggerValue: getEnableClearDesignQuestionList(formValues['UpperFixedWire'] , true),
    //   formMethods:formMethods,
    //   formValues:formValues,
    //   // exceptionalBool : formValues['UpperArchAndQuantity'] === 'ecodontRetainers' && formValues['UpperClearRetainerDesignUpperOption'] === 'virtuallyRemoveLingualOrPalatalWire' && formValues['UpperFixedWire'] === 'true'
    // })

    // useSetSelectDefaultValue({
    //   parentField:'UpperClearRetainerDesignLowerForSecondSet',
    //   childField:'UpperClearRetainerDesignLowerOptionForSecondSet',
    //   defaultValue:'NotCoverLingualOrPalatalWire',
    //   triggerValue:true,
    //   formMethods:formMethods,
    //   formValues:formValues
    // })

    // for lower clear retainer questions

    // useSetSelectDefaultValue({
    //   // parentField:'LowerClearRetainerDesignUpper',
    //   parentField:'LowerArchAndQuantity',
    //   childField:'LowerClearRetainerDesignUpperOption',
    //   defaultValue:'NotCoverLingualOrPalatalWire',
    //   // triggerValue:true,
    //   triggerValue:ENABLE_CLEAR_DESIGN_QUESTION,
    //   formMethods:formMethods,
    //   formValues:formValues
    // })

    useSetSelectDefaultValue({
        // parentField:'LowerClearRetainerDesignLower',
        parentField: 'LowerArchAndQuantity',
        childField: 'LowerClearRetainerDesignLowerOption',
        defaultValue: lowerIsVeneerShieldRetainer ? undefined : 'NotCoverLingualOrPalatalWire',
        // triggerValue:true,
        // triggerValue:ENABLE_CLEAR_DESIGN_QUESTION,
        triggerValue: getEnableClearDesignQuestionList(formValues['LowerFixedWire'], false),
        formMethods: formMethods,
        formValues: formValues,
    });

    // useSetSelectDefaultValue({
    //   parentField:'LowerClearRetainerDesignUpperForSecondSet',
    //   childField:'LowerClearRetainerDesignUpperOptionForSecondSet',
    //   defaultValue:'NotCoverLingualOrPalatalWire',
    //   triggerValue:true,
    //   formMethods:formMethods,
    //   formValues:formValues
    // })

    // useSetSelectDefaultValue({
    //   // parentField:'LowerClearRetainerDesignLowerForSecondSet',
    //   parentField:'LowerArchAndQuantity',
    //   childField:'LowerClearRetainerDesignLowerOptionForSecondSet',
    //   defaultValue: formValues['LowerArchAndQuantity'] === 'ecodontRetainers' && formValues['LowerFixedWire'] === 'true' ? 'NotCoverLingualOrPalatalWire' : undefined,
    //   triggerValue: getEnableClearDesignQuestionList(formValues['LowerFixedWire'] , true),
    //   formMethods:formMethods,
    //   formValues:formValues,
    //   // exceptionalBool : formValues['LowerArchAndQuantity'] === 'ecodontRetainers' && formValues['LowerClearRetainerDesignLowerOption'] === 'virtuallyRemoveLingualOrPalatalWire' && formValues['LowerFixedWire'] === 'true'
    // })

    // for upper pontic
    // useSetSelectDefaultValue({
    //   parentField:'UpperArchAndQuantity',
    //   childField:'UpperPontic',
    //   defaultValue:'insertAPontic',
    //   triggerValue:ENABLE_POTIC_RETAINER_TYPE,
    //   formMethods:formMethods,
    //   formValues:formValues
    // })

    useSetSelectDefaultValue({
        parentField: 'UpperPontic',
        childField: 'UpperPonticColor',
        defaultValue: 'A2',
        // triggerValue:'insertAPontic',
        triggerValue: 'colourPonticRequired',
        formMethods: formMethods,
        formValues: formValues,
    });

    // for lower pontic
    // useSetSelectDefaultValue({
    //   parentField:'LowerArchAndQuantity',
    //   childField:'LowerPontic',
    //   defaultValue:'insertAPontic',
    //   triggerValue:ENABLE_POTIC_RETAINER_TYPE,
    //   formMethods:formMethods,
    //   formValues:formValues
    // })

    useSetSelectDefaultValue({
        parentField: 'LowerPontic',
        childField: 'LowerPonticColor',
        defaultValue: 'A2',
        // triggerValue:'insertAPontic',
        triggerValue: 'colourPonticRequired',
        formMethods: formMethods,
        formValues: formValues,
    });
};

export default useSetCombieFormDefaultValue;
